import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiRadio } = FiIcons;

const Header = () => {
  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed top-0 left-0 right-0 z-50 glass-effect"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-start">
          <a href="#" className="flex items-center space-x-3 max-w-full">
            <div className="relative flex items-center justify-center w-10 h-10 flex-shrink-0">
              <div className="absolute -inset-1 radio-waves-sm border-crimson-400/50"></div>
              <div className="absolute -inset-1 radio-waves-sm border-crimson-400/50" style={{ animationDelay: '1s' }}></div>
              <SafeIcon icon={FiRadio} className="text-3xl text-cream-400" />
            </div>
            <span className="text-lg sm:text-2xl font-bold text-white text-glow truncate">
              <span className="hidden sm:inline">Ligon Road Innovations LLC Station</span>
              <span className="inline sm:hidden">LRI Station</span>
            </span>
          </a>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;